module.exports = __webpack_public_path__ + "img/view_doc.757c5e27.svg";